import { useEffect, useState } from 'react'

import { SelectFormField } from '@/components/UberForm'
import {
	formatStructureOptionLabel,
	useAppContext,
	useDebounce,
	useStructureSearch,
} from '@/hooks'
import {
	CustomMenuList,
	CustomOption,
} from '@/lib/components/Select/CustomSelectComponents'
import { WriteMappingData } from '@/pages/User/pages/Home/types'

type Props = {
	onChangeWriteMapping: (value: WriteMappingData) => void
}

export const AddModalWriteMapping = ({ onChangeWriteMapping }: Props) => {
	const { t } = useAppContext()

	const [search, setSearch] = useState('')

	const searchDebounced = useDebounce(search, 300)

	const { loadOptions, searchOptions, isFetching } = useStructureSearch({
		types: ['TABLE'],
	})

	// Load initial options on mount
	useEffect(() => {
		loadOptions()
	}, [])

	// Search when user types
	useEffect(() => {
		if (searchDebounced) {
			loadOptions(searchDebounced)
		}
	}, [searchDebounced])

	return (
		<SelectFormField
			title={t('TARGET_TABLE')}
			name="targetTableId"
			testId="targetTable"
			options={searchOptions}
			fieldIsLoading={isFetching}
			valueKey="id"
			labelKey="name"
			required
			isNumeric
			onInputChange={(search) => {
				if (search) {
					setSearch(search)
				}
			}}
			placeholder={t('SEARCH')}
			onChange={(value) => {
				if (value) {
					const fullPath = searchOptions.find(
						(element) => element.id === value,
					)?.fullPath

					onChangeWriteMapping({
						targetTableFullPath: fullPath ?? '',
					})
				}
			}}
			formatOptionLabel={formatStructureOptionLabel}
			components={{ Option: CustomOption, MenuList: CustomMenuList }}
		/>
	)
}
